import React, { Fragment, useEffect, useState } from 'react'
import { useQuery, useMutation } from '@apollo/client'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Box from '../../Global/Box'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import { showTransformItem } from './helpers/configAppPageHelper'
import Spacer from './components/Spacer'
import HeaderText from './components/HeaderText'
import BannerImageSingle from './components/BannerImageSingle'
import ButtonsBox from './components/ButtonsBox'
import BannerImageCarousel from './components/BannerImageCarousel'
import ConfigOrderingModal from './ConfigAppPageOrderingModal'
import { useLoading } from '../../../LoadingOverlay/LoadingOverlayContext'
import { GET_ALL_CONFIG_APP_PAGES } from '../../../graphql/ConfigApp/configAppPages'
import {
  DELETE_CONFIG_APP_PAGE_ELEMENT,
  GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
  ORDER_CONFIG_APP_PAGE_ELEMENT,
  ORDER_CONFIG_APP_PAGE_ELEMENT_ITEMS,
} from '../../../graphql/ConfigApp/configAppPageElements'
import HtmlContent from './components/HtmlContent'

const idModal = 'modalOrder'

const ConfigAppPageElements = ({ pageId }) => {
  const { showLoading, hideLoading } = useLoading()

  const MySwal = withReactContent(Swal)

  //STATES:
  const [dataMain, setDataMain] = useState(null)
  const [dataElement, setDataElement] = useState(null)
  const [modalOrden, setModalOrden] = useState(false)
  const [modalConfig, setModalConfig] = useState({
    title: '',
  })

  //MUTATIONS:
  const [deleteConfigAppPageElement] = useMutation(
    DELETE_CONFIG_APP_PAGE_ELEMENT,
    {
      refetchQueries: [
        {
          query: GET_ALL_CONFIG_APP_PAGES,
          variables: {
            limit: 10,
            offset: 0,
            searchQuery: null,
          },
        },
        {
          query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
          variables: {
            configAppPageId: pageId,
          },
        },
      ],
    }
  )

  const [orderConfigAppPageElement] = useMutation(
    ORDER_CONFIG_APP_PAGE_ELEMENT,
    {
      refetchQueries: [
        {
          query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
          variables: {
            configAppPageId: pageId,
          },
        },
      ],
    }
  )

  const [orderConfigAppPageElementItems] = useMutation(
    ORDER_CONFIG_APP_PAGE_ELEMENT_ITEMS,
    {
      refetchQueries: [
        {
          query: GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE,
          variables: {
            configAppPageId: pageId,
          },
        },
      ],
    }
  )

  //QUERIES:
  const {
    data: dataResp,
    loading,
    error,
  } = useQuery(GET_ALL_ELEMENTS_OF_CONFIG_APP_PAGE, {
    variables: {
      configAppPageId: pageId,
    },
  })

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (pageId) {
        if (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }

        if (dataResp !== undefined && dataResp !== null) {
          const data = dataResp.getAllConfigAppPageElementsByConfigAppPageId

          let elements = []

          data.map((element) => {
            const elementJson = JSON.parse(element.json_config)
            if (element.json_items_config) {
              elementJson.items = JSON.parse(element.json_items_config)
            }

            return elements.push({
              id: element.id,
              config_app_page_id: element.config_app_page_id,
              order: element.order,
              layout: element.layout,
              itemMain: elementJson,
            })
          })

          setDataMain(elements)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageId, dataResp, error, loading])

  console.log({ dataMain })

  const handleShowModal = async ({ type, index }) => {
    try {
      if (type === 'all') {
        setModalConfig({
          title: `Reordenamiento principal`,
          dataMain: dataMain,
          setDataMain: setDataMain,
          level: 'all',
        })
      }

      if (type === 'sub1') {
        setModalConfig({
          title: `Reordenamiento interno`,
          index,
          dataMain: dataMain,
          setDataMain: setDataMain,
          level: 'sub1',
        })
      }

      setModalOrden(true)
    } catch (error) {
      console.log({ error })
    }
  }

  const processInfoShowItem = ({ element, index }) => {
    if (!element?.itemMain?.items || element?.itemMain?.items.length === 0) {
      return showTransformItem(element.itemMain)
    }

    if (element?.layout === 'banner_image_carousel') {
      return showTransformItem(element.itemMain)
    }

    if (element?.itemMain?.items && element?.itemMain.items.length > 0) {
      return (
        <>
          <Box
            clasCard="card my-1 rounded"
            classNameHeader={`card-header ${
              element.itemMain.items.length > 1 ? 'pt-3' : 'py-1'
            }`}
            contentHeader={
              <>
                <h3 className="card-title pl-3 mt-0">{element.layout}</h3>
                {element.itemMain.items.length > 1 && (
                  <div className="card-tools mr-2">
                    <button
                      className="btn btn-sm btn-migrates"
                      title="Ordenar seccion"
                      data-toggle="modal"
                      data-target={`#${idModal}`}
                      onClick={() =>
                        handleShowModal({
                          type: 'sub1',
                          index: index,
                        })
                      }
                    >
                      <i className="fas fa-retweet" />
                    </button>
                  </div>
                )}
              </>
            }
            content={
              <>
                <div
                  className="d-flex flex-wrap justify-content-center"
                  style={{ gap: 10 }}
                >
                  {element.layout === 'banner_image_carousel'
                    ? showTransformItem(element.itemMain)
                    : element.itemMain.items.map((itemSub1, indexSub1) => {
                        return (
                          <Fragment key={indexSub1}>
                            {showTransformItem(itemSub1)}
                          </Fragment>
                        )
                      })}
                </div>
              </>
            }
          />
        </>
      )
    }
  }

  const handleEditElement = ({ element }) => {
    setDataElement(element)
  }

  const handleDeleteElement = ({ element }) => {
    MySwal.fire({
      showCloseButton: true,
      icon: 'warning',
      title: '¿Estas seguro de eliminar este elemento?',
      html: <div className="message-container">Esta accion es permanente</div>,
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-migrates',
        denyButton: 'btn btn-migrates-white',
        footer: 'btn StandarModalFooterLogOut',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        showLoading()
        try {
          await deleteConfigAppPageElement({
            variables: { id: element.id },
          })

          return toastSweetAlert({
            mode: 'ok',
            message: 'El Elemento ha sido eliminado',
          })
        } catch (error) {
          toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        } finally {
          hideLoading()
        }
      }
    })
  }

  const handleAddElement = async () => {
    setDataElement(null)
    const { value: typeElement } = await Swal.fire({
      title: 'Elige tipo de elemento',
      input: 'select',
      inputOptions: {
        spacer: 'Espacio',
        header_text: 'Titulo',
        buttons_box: 'Caja de botones',
        banner_image_single: 'Banner una imagen',
        banner_image_carousel: 'Banner varias imagenes',
        html_content: 'Contenido HTML',
      },
      inputPlaceholder: 'Elige uno',
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value === '') {
            resolve('Debes elegir una opcion')
          } else {
            resolve()
          }
        })
      },
    })
    if (typeElement) {
      setDataElement({
        layout: typeElement,
        config_app_page_id: pageId,
      })
    }
  }

  const handleOrder = async ({ items, index = null, level }) => {
    if (level === 'all') {
      const itemsOrder = items.map((item, index) => ({
        id: item.id,
        order: index + 1,
      }))

      showLoading()

      try {
        await orderConfigAppPageElement({
          variables: { pageId, input: itemsOrder },
        })
      } catch (error) {
        toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
      } finally {
        hideLoading()
      }
    }

    if (level === 'sub1') {
      const json_items_config = JSON.stringify(items[index].itemMain.items)

      showLoading()

      try {
        await orderConfigAppPageElementItems({
          variables: {
            elementId: parseInt(items[index].id),
            json_items_config,
          },
        })
      } catch (error) {
        toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
      } finally {
        hideLoading()
      }
    }
  }

  return (
    <>
      <div className="d-flex flex-wrap" style={{ gap: '5px 20px' }}>
        <div style={{ width: '90mm' }}>
          <Box
            contentHeader={
              <>
                <h3 className="card-title pl-3 mt-0">Elementos</h3>
                <div className="card-tools mr-2">
                  <button
                    className="btn btn-sm btn-migrates mr-3"
                    title="Agregar elemento"
                    onClick={() => handleAddElement()}
                  >
                    <i className="fas fa-plus" /> Agregar
                  </button>

                  <button
                    className="btn btn-sm btn-migrates"
                    title="Ordenar seccion"
                    data-toggle="modal"
                    data-target={`#${idModal}`}
                    onClick={() => handleShowModal({ type: 'all' })}
                  >
                    <i className="fas fa-retweet" />
                  </button>
                </div>
              </>
            }
            content={
              <>
                {dataMain && (
                  <div className="d-flex flex-column" style={{ gap: 20 }}>
                    {dataMain.map((element, index) => {
                      return (
                        <div
                          key={element.id}
                          className="bg-lightblue rounded rounded-3"
                        >
                          <div className="d-flex flex-column">
                            <div
                              className="d-flex justify-content-end mb-3"
                              style={{ gap: 10 }}
                            >
                              <button
                                className="btn btn-sm btn-migrates"
                                onClick={() => handleDeleteElement({ element })}
                              >
                                <i className="fas fa-trash-alt" />
                              </button>
                              <button
                                className="btn btn-sm btn-migrates"
                                onClick={() => handleEditElement({ element })}
                              >
                                <i className="fas fa-edit" />
                              </button>
                            </div>
                            <div className="text-center px-3 pb-3">
                              {processInfoShowItem({ element, index })}
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )}
              </>
            }
          />
        </div>

        <div className="flex-grow-1 col-8">
          {dataElement && (
            <Box
              contentHeader={
                <h3 className="card-title pl-3 mt-0">
                  {`${
                    dataElement?.id
                      ? 'Configuracion elemento'
                      : 'Crear nuevo elemento'
                  }`}
                  {dataElement &&
                    dataElement?.layout &&
                    ` (${dataElement?.layout})`}
                </h3>
              }
              content={
                <>
                  {dataElement?.layout === 'spacer' && (
                    <Spacer
                      pageId={pageId}
                      dataElement={dataElement}
                      setDataElement={setDataElement}
                    />
                  )}

                  {dataElement?.layout === 'header_text' && (
                    <HeaderText
                      pageId={pageId}
                      dataElement={dataElement}
                      setDataElement={setDataElement}
                    />
                  )}

                  {dataElement?.layout === 'banner_image_single' && (
                    <BannerImageSingle
                      pageId={pageId}
                      dataElement={dataElement}
                      setDataElement={setDataElement}
                    />
                  )}

                  {dataElement?.layout === 'buttons_box' && (
                    <ButtonsBox
                      pageId={pageId}
                      dataElement={dataElement}
                      setDataElement={setDataElement}
                    />
                  )}

                  {dataElement?.layout === 'banner_image_carousel' && (
                    <BannerImageCarousel
                      pageId={pageId}
                      dataElement={dataElement}
                      setDataElement={setDataElement}
                    />
                  )}

                  {dataElement?.layout === 'html_content' && (
                    <HtmlContent
                      pageId={pageId}
                      dataElement={dataElement}
                      setDataElement={setDataElement}
                    />
                  )}
                </>
              }
            />
          )}
        </div>
      </div>

      {modalOrden && (
        <ConfigOrderingModal
          idModal={idModal}
          modal={modalOrden}
          setModal={setModalOrden}
          config={modalConfig}
          handleOrder={handleOrder}
        />
      )}
    </>
  )
}

export default ConfigAppPageElements
